import { render } from "./TrackingPointNameBox.vue?vue&type=template&id=edb1437e&scoped=true"
import script from "./TrackingPointNameBox.vue?vue&type=script&lang=ts"
export * from "./TrackingPointNameBox.vue?vue&type=script&lang=ts"

import "./TrackingPointNameBox.vue?vue&type=style&index=0&id=edb1437e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-edb1437e"

export default script